export default __webpack_public_path__ + "static/media/desco-logo-blk.ace0ce9e.svg";